import 'react-multi-carousel/lib/styles.css'
import React, { Fragment, use, useContext, useEffect, useRef, useState } from 'react'
import AuthContext from 'store/auth-context'
import Image from 'next/image'
import cf from '@/lib/utils/common'
import parse from 'html-react-parser'
import styles from './index.module.css'
import { useRouter } from 'next/router'
import { getStorage } from '../../../../common/lib/utils/localStorage'
import CustomLink from '@/components/Link'
import { getCookieTocken } from '@/commonComponents/login/userToken.js'
import { getProfileData } from '../../../lib/myProfile'
import { tourCarousel } from '../../../lib/tourCarousel'
import static_config from '../../../../common/lib/utils/enum.json'
import TravelDealsCarousel from '@/components/common/TravelDealsCarousel/TravelDealsCarousel'
import HolidayPromo from '@/components/common/HolidayPromo/HolidayPromo'
import { getRecentSearch } from '../../../lib/home/homepage'

import TrustedPartnerCarousel from '@/components/PageBreakUp/HolidayPackages/TrustedPartnerCrousel'
import { getTrustedPartnerList } from '@/lib/trustedPartnerData'
import StaticContent from '@/components/StaticContent'
import ShareToMedia from '@/components/common/ShareToMedia'

import {
  myGreetingMySwiper,
  myGreetingMySwiper2,
  myGreetingElevatenew,
  myGreetingCruiseHolidays,
  myGreetingChild_featureSwiper,
  myGreetingTestimonial_data,
  myGreetingMyclientSwiper,
  myGreetingOffermain,
  myGreetingNewlyadded,
  myGreetingMostbooked,
  myGreetingHoneymoonpkg,
  myGreetingExploremain,
  myGreetingBudgetSwiper,
  offerSwiper,
  myGreetingPopularSwiper,
  myGreetingNetworkslider,
  myGreetingCardSwiper,
  lazyyoutube,
  myGreetingsliderthreeonehalf,
  myGreetingsliderfivetwohalf,
  myGreetingsliderfourtwohalf,
  myGreetingsliderfouronehalf,
  myGreetingslidersixtwohalf,
} from '../../../public/js/carousalFun'
import dynamic from 'next/dynamic'

const HolidaySearchWidget = dynamic(() => import('../../common/holiday/widgets'))
const Carousel = dynamic(() => import('react-multi-carousel'))

let initRoom = static_config.roomConfig.defaultRoomsVal

export default function index(props) {
  const { site_id, isMobile } = props
  const ctx = useContext(AuthContext)
  const router = useRouter()
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const wrapperRef = useRef(null)
  const [expandHotelNameBoolean, setExpandHotelName] = useState(false)
  const [getHotelAutoSuggestList, setHotelAutoSuggestList] = useState([])
  const [initHotelData, setInitHotelData] = useState([])
  const [homeBody, setHomeBody] = useState([])
  const [homeBodyMobile, setHomeBodyMobile] = useState([])
  const [firstNobannerId, setFirstNoBannerId] = useState(null)
  const [lastNobannerId, setLastNoBannerId] = useState(null)
  const [hotelDefultDays, setHotelDefultDays] = useState(0)
  const [userProfile, setUserProfile] = useState('')
  const [searchWidget, setSearchWidget] = useState('')
  // const [SerachWidMob, setSerachWidMob] = useState('')
  const [recentSearchData, setRecentSearchData] = useState([])
  const [isDesktopDefaultImg, setIsDesktopDefaultImg] = useState(false)
  const [isMobDefaultImg, setIsMobDefaultImg] = useState(false)
  const [section, setSection] = useState('home')
  const [profileData, setprofileData] = useState({})
  const [isProfileData, setIsProfileData] = useState(false)
  const [partnerdata, setPartnerdata] = useState([])
  const [state, setState] = useState({
    showBreakfast: false,
    showFreeCancellation: false,
    recentSearchClicked: true,
    hotelName: '',
    getDestinationId: '',
    getSearchType: 6,
    property_count: '',
    dest_type: { code: '', text: '' },
  })
  const [showWidgets, setShowWidgets] = useState(false)
  const [showBalance, setShowBalance] = useState(false)
  const [currencyList, setCurrencyList] = useState([])
  const [currency, setCurrency] = useState('')
  const [availableBalance, setAvailableBalance] = useState({
    creditAmount: 0,
    balanceAmount: 0,
    usedAmount: 0,
  })
  const [isLoadingBalance, setIsLoadingBalance] = useState(false)
  const [flightSectorLength, setFlightSectorLength] = useState(1)
  const [balanceError, setBalanceError] = useState(false)
  const [tourCarouselData, setTourCarouselData] = useState([])
  const [loading, setLoading] = useState(true)
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [partUrl, setPartUrl] = useState("");

  const fullName = ctx?.user?.first_name + ' ' + ctx?.user?.last_name

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      // slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }


  useEffect(() => {
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem('hotelSearchKey')
      if (data !== null) {
      } else {
        console.log('No data found shreyash')
      }
    }
  }, [])

  const getTourCarouselData = () => {
    let req = {
      site_id: props.site_id || '',
      limit: 10,
      offset: 0,
    }
    tourCarousel(req).then((res) => {
      if (res && res.status === true) {
        setTourCarouselData(res.data.data)
        setLoading(false)
      }
    })
  }
  

  useEffect(() => {
    getProfileDatafun()
    getTourCarouselData()
    let userToken = cf.getCookieTocken('userToken')
    cf.getUserProfile(userToken, props.site_id).then((res) => {
      if (res.status === true) {
        setUserProfile(ctx?.user)
      } else {
        setUserProfile(res)
      }
    })
    updateHomeBody()
    if (props?.home?.data?.data?.body?.desktop) {
      /**FIND FIRST AVILLABLE WIDGET**/

      let defaultService = props.home.data.data.header.menu?.filter(
        (ele) => ele.status.toLowerCase() == 'active'
      )
      // if (defaultService?.length > 0) {
      //   setSearchWidget(defaultService[0].code)
      //   setIsActive(defaultService[0].code)
      // }

      let defaultImgDesktop = props.home.data.data.body.desktop?.filter(
        (ele) => ele.type == 'image_carousal'
      )
      if (defaultImgDesktop?.length == 0) {
        setIsDesktopDefaultImg(true)
      }

      let defaultImgMob =
        props?.home?.data?.data?.body?.mobile?.length > 0 &&
        props?.home?.data?.data?.body?.mobile?.filter((ele) => ele.type == 'image_carousal')
      if (defaultImgMob?.length == 0) {
        setIsMobDefaultImg(true)
      }

      let hotelIndex = props.home.data.data.body.desktop.findIndex(
        (items) => items.type === 'hotel_search'
      )
      if (hotelIndex > -1) {
        setHotelDefultDays(props.home.data.data.body.desktop[hotelIndex].default_days)
      }
    }

    const style = document.createElement('style')
    if (
      !cf.isValueEmpty(props) &&
      !cf.isValueEmpty(props.home) &&
      !cf.isValueEmpty(props.home.data)
    ) {
      style.innerHTML = props.home.data.data.css
      document.head.appendChild(style)
    }
    setActiveItemIndex(activeItemIndex)
    if (!cf.isValueEmpty(props) && !cf.isValueEmpty(props.home) && props.home.status === true) {
      if (
        !cf.isValueEmpty(props.home.data.data) &&
        !cf.isValueEmpty(props.home.data.data.body) &&
        !cf.isValueEmpty(props.home.data.data.body.desktop) &&
        props.home.data.data.body.desktop.length > 0
      ) {
        let hotelIndex = props.home.data.data.body.desktop.findIndex(
          (items) => items.type === 'hotel_search'
        )

        if (hotelIndex !== -1) {
          if (
            !cf.isValueEmpty(props.home.data.data.body.desktop[hotelIndex].locations) &&
            props.home.data.data.body.desktop[hotelIndex].locations.length > 0
          ) {
            setInitHotelData([...props.home.data.data.body.desktop[hotelIndex].locations])
            setHotelAutoSuggestList([...props.home.data.data.body.desktop[hotelIndex].locations])
          }
        }
      }
    }

    let LocalSearch = getStorage('hotelSearchKey')

    let LocalSearchAll = getStorage('hotelSearchKeyAll')

    if (LocalSearchAll !== null) {
      setRecentSearchData(LocalSearchAll ? JSON.parse(LocalSearchAll) : [])
    }
    if (LocalSearch !== null && LocalSearchAll == null) {
      setRecentSearchData([LocalSearch ? JSON.parse(LocalSearch) : {}])
    }

    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])

  useEffect(() => {
    if (recentSearchData && recentSearchData.length > 0) {
      recentSearchData.map((element, index) => {
        if (index == 0) {
          setState({
            showBreakfast: element?.is_breakfast,
            showFreeCancellation: element?.is_free_cancellation,
          })
        }
      })
    }
  }, [recentSearchData])

  useEffect(() => {
    try {
      updateHomeBody()

      if (router.asPath == '/holidays' || router.asPath == '/holiday') {
        setSearchWidget('holiday')
      } else if (router.asPath === '/tourpackages') {
        setSearchWidget('tourpackages')
      }

      setTimeout(() => {
        myGreetingMySwiper(),
          myGreetingMySwiper2(),
          myGreetingElevatenew(),
          myGreetingCruiseHolidays(),
          myGreetingChild_featureSwiper(),
          myGreetingTestimonial_data(),
          myGreetingMyclientSwiper(),
          myGreetingOffermain(),
          myGreetingNewlyadded(),
          myGreetingMostbooked(),
          myGreetingHoneymoonpkg(),
          myGreetingExploremain(),
          myGreetingBudgetSwiper(),
          offerSwiper(),
          myGreetingPopularSwiper(),
          myGreetingNetworkslider(),
          myGreetingCardSwiper(),
          lazyyoutube(),
          myGreetingsliderthreeonehalf(),
          myGreetingsliderfivetwohalf(),
          myGreetingsliderfourtwohalf(),
          myGreetingsliderfouronehalf(),
          myGreetingslidersixtwohalf()
      }, 100)
    } catch (error) {
      console.log(error)
    }
  }, [query])


  useEffect(() => {

    getTrustedPartnerList({ site_id }).then((res) => {
      if (res && res.status === true) {
        setPartnerdata(res?.data?.data?.map((item) => {
          return {
            ...item,
          }
        }))
      }
    })
  }, [])

  function getProfileDatafun() {
    let data = {
      accessToken:
        getCookieTocken('userToken') !== undefined &&
          getCookieTocken('userToken') !== null &&
          getCookieTocken('userToken') !== ''
          ? getCookieTocken('userToken')
          : '',
      site_id: props.site_id || '',
    }
    getProfileData(data).then((res) => {
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setIsProfileData(true)
        let proData = res.data.data[0]
        setprofileData({ ...proData })
        // setIsLoader(false)
      }
    })
  }

  const updateHomeBody = () => {
    const homeBodyRes = props?.home?.data?.data?.body?.desktop // props?.isMobile ? props?.home?.data?.data?.body?.mobile : props?.home?.data?.data?.body?.desktop
    const homeBodyMobileRes = props?.home?.data?.data?.body?.mobile
    const firstNobanner = homeBodyRes?.find((item) => item.banner_data === 'nobanner')
    const lastNobanner = homeBodyRes?.filter((item) => item.banner_data === 'nobanner').pop()
    const firstNobannerOrder = firstNobanner ? firstNobanner?.order : null
    const lastNobannerOrder = lastNobanner ? lastNobanner?.order : null
    setHomeBody(homeBodyRes || [])
    setHomeBodyMobile(homeBodyMobileRes || [])
    setFirstNoBannerId(firstNobannerOrder)
    setLastNoBannerId(lastNobannerOrder)
    setCurrency(ctx?.user?.org_dtls?.default_currency)
    const currencyData = [{ id: 0, label: ctx?.user?.org_dtls?.default_currency }]
    if (ctx?.user?.org_dtls?.secondary_currency && ctx?.user?.org_dtls?.secondary_currency !== '') {
      currencyData.push({ id: 1, label: ctx?.user?.org_dtls?.secondary_currency })
    }
    setCurrencyList(currencyData)
  }

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if (expandHotelNameBoolean === true) setExpandHotelName(false)
    }
  }

  const imageLoader = ({ src }) => {
    return `${'/shared/api/media/' + props.site_id + '/' + src}`
  }

  const query = router.query.index

  function saveRecentSearch(searchKey, searchKeyAll, searchData) {
    let recentAll = JSON.parse(localStorage.getItem(searchKeyAll)) || []
    recentAll = recentAll.filter((item) => item.name !== searchData.name)
    recentAll.unshift(searchData)
    if (recentAll.length > 5) recentAll.pop()
    localStorage.setItem(searchKeyAll, JSON.stringify(recentAll))
    localStorage.setItem(searchKey, JSON.stringify(searchData))
  }

  function handleRecentSearch(searchData) {
    // Guest user, save to localStorage
    saveRecentSearch('hotelSearchKey', 'hotelSearchKeyAll', searchData)
    const LocalSearch = localStorage.getItem('hotelSearchKeyAll')
    if (LocalSearch) {
      setRecentSearchData(JSON.parse(LocalSearch))
    } else {
      setRecentSearchData([])
    }
    // if (ctx?.user && ctx?.user?._id) {
    //   // Fetch recent searches from backend
    //     getRecentSearch({ service: 'holiday' }).then((result) => {
    //       console.log('Recent search API result:', result);
    //       if (result && result.data) {
    //         setRecentSearchData(result.data); // adjust according to your API response
    //       }
    //     });
    // } 
  }

  const renderWidgets = () => {
    return (
      <>
        {homeBody.map((res, i) => {
          return (
            <div key={'homeBodyDsktp' + i}>
              {(
                router.pathname === '/' ||
                searchWidget === 'holiday' ||
                searchWidget === 'tourpackages') &&
                res.type == 'holiday_search' && (
                  <div>
                    <HolidaySearchWidget
                      theme={props?.home?.data?.site?.site_theme}
                      isMobile={props.isMobile}
                      checkinFormat={'dd MMM yyyy'}
                      checkoutFormat={'dd MMM yyyy'}
                      query={router.query}
                      cmsPopularData={[]}
                      currencyList={currencyList}
                      default_currency={ctx?.user?.org_dtls?.default_currency}
                      body={props?.home?.data?.data?.body}
                      onSearch={handleRecentSearch}
                    />
                  </div>
                )}
            </div>
          )
        })}
      </>
    )
  }

  useEffect(() => {
    const sectorId = document.getElementById('home_widget_container_multicity')
    if (sectorId && !props?.isMobile && flightSectorLength > 1) {
      sectorId.style.height = `${450 + 70 * (flightSectorLength - 1)}px`
    } else if (sectorId) {
      sectorId.style.removeProperty('height')
    }
  }, [flightSectorLength])

  useEffect(() => {
    const handleShareClick = (e) => {
      const shareBtn = e.target.closest(".btn__share");
      if (!shareBtn) return;

      e.preventDefault(); // prevent <a> navigation
      e.stopPropagation(); // stop bubbling if needed

      // Get the closest parent card link
      const cardLink = shareBtn.closest("a");
      // If no <a>, use window.location.href
      const shareUrl = cardLink?.href;
      setPartUrl(shareUrl);
      setShareModalOpen(true);
    };

    document.addEventListener("click", handleShareClick);
    return () => document.removeEventListener("click", handleShareClick);
  }, []);


  return (
    <>
      {props.isMobile ? (
        <div
          className={`${styles.home_container} ${showWidgets ? styles.home_container_mobile : ''} `}
        >
          <>
            {searchWidget === 'tourpackages' && (
              <StaticContent
                description="Whether you're looking for relaxation, adventure, or something in between, our platform helps you find the perfect trip with zero hassle. From weekend escapes to long-haul journeys, everything you need is right here - simple, fast, and tailored to you."
              />
            )}

            {searchWidget !== 'tourpackages' && (
              <>
                <div className={styles.tour_story}>
                  <HolidayPromo />
                </div>

                {tourCarouselData?.length > 0 && (
                  <div className={styles.tour_carousel}>
                    <TravelDealsCarousel isMobile={props.isMobile} tourCarouselData={tourCarouselData} loading={loading} />
                  </div>
                )}
              </>
            )}

            <div className={styles.holiday_widget_wrap}>
              <div className={styles.search_widget_container}>
                <img src="images/tholidays.svg" alt="holiday icon" /> Holidays
              </div>
              <div className={styles.search_widget_body}>{renderWidgets()}</div>
              {
                searchWidget === 'tourpackages' && (
                  <div className={styles.recent_search}>
                    Recent Searches :
                    <div className={styles.recent_search_items}>
                      {recentSearchData && recentSearchData.length > 0 ? (
                        recentSearchData.map((item, idx) => (
                          <div
                            className={styles.search_item_name}
                            key={idx}
                            onClick={() => {
                              const urlQuery = {
                                searchby: item.name,
                                type: item.type,
                                category: '',
                                city: '',
                                month: '',
                                client: '',
                              }
                              cf.redirectTo('/holiday/search', urlQuery)
                            }
                            }
                          >
                            {item.name}
                          </div>
                        ))
                      ) : (
                        <div className={styles.search_item_name}>No recent searches</div>
                      )}
                    </div>
                  </div>
                )
              }
            </div>
          </>

          <div className={styles.home_body_container}>
            <div>
              {homeBodyMobile.map((res, i) => {
                return (
                  <div key={'homeBodyMobile' + i}>
                    <div>
                      {!cf.isValueEmpty(res.html)
                        ? parse(res.html)
                        : // <Interweave content={res.html} />
                        ''}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>


          {
            (searchWidget == 'tourpackages') && (
              <div className={styles.tour_carousel_mob}>
                <h2 className={styles.tour_carousel_title}>Trusted partners in every holiday</h2>
                <p className={styles.tourCarousel_text}>we proudly collaborate with a curated network of holiday partners who help us deliver outstanding travel experiences around the world.</p>
                <div className={styles.tour_carousel_bottom}>
                  <TrustedPartnerCarousel partnerdata={partnerdata} isMobile={isMobile} />
                </div>
              </div>
            )
          }
        </div>
      ) : (
        <div
          className={`${styles.home_container} ${searchWidget === 'tourpackages' ? styles.holiday_packages : ''} ${searchWidget === 'tourpackages' ? styles.holiday_packages : ''}`}
        >
          {(router.pathname === '/' || searchWidget == 'holiday' || searchWidget == 'holidays') && (
            <div className={styles.tour_carousel}>
              <TravelDealsCarousel tourCarouselData={tourCarouselData} isMobile={props.isMobile} loading={loading} />
            </div>
          )}

          <div className={`${styles.home_widget_container} ${(!loading && !tourCarouselData?.length && searchWidget !== 'tourpackages') && styles.without_tour_carousel} `} id={'home_widget_container_multicity'}>
            <div
              className={`${searchWidget === 'tourpackages' ? styles.holiday_packages_banner : styles.home_banner}`}
            >
              {homeBody.map((res, i) => {
                return (
                  <div key={'homeBodyDsktp' + i}>
                    {!cf.isValueEmpty(res.type) &&
                      res.type == 'image_carousal' &&
                      (res.banners && res.banners.length > 0 ? (
                        <div
                          className={`${props.isMobile ? styles.carousal_container : styles.carouse_container2}`}
                          style={{ margin: 0 }}
                        >
                          <Carousel
                            swipeable={false}
                            draggable={false}
                            showDots={false}
                            responsive={responsive}
                            ssr={false} // means to render carousel on server-side.
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={3000}
                            keyBoardControl={true}
                            customTransition="all .5"
                            transitionDuration={500}
                            containerClass={styles.carouse_container2}
                            //  containerClass="carousel-container"
                            // deviceType={this.props.deviceType}
                            dotListClass="custom-dot-list-style"
                            itemClass="carousel-item-padding-40-px"
                          >
                            {!cf.isValueEmpty(res) &&
                              !cf.isValueEmpty(res.banners) &&
                              res.banners.length > 0 &&
                              res.banners.map((imagedata, index) => {
                                return (
                                  <div
                                    style={{ margin: 0 }}
                                    key={'banner' + index}
                                    className={styles.img_banner_home2}
                                  >
                                    {imagedata.banner_url ? (
                                      <CustomLink href={imagedata.banner_url}>
                                        <Image
                                          loader={imageLoader}
                                          src={
                                            props?.isMobile ? imagedata?.r_image : imagedata?.image
                                          }
                                          width={500}
                                          layout="fill"
                                          alt="image-carousel"
                                        />
                                      </CustomLink>
                                    ) : (
                                      <Image
                                        loader={imageLoader}
                                        src={imagedata?.image}
                                        width={500}
                                        layout="fill"
                                        alt="image-carousel"
                                      />
                                    )}
                                  </div>
                                )
                              })}
                          </Carousel>
                        </div>
                      ) : (
                        <div className={styles.nobanner}></div>
                      ))}
                  </div>
                )
              })}
            </div>
            <div className={styles.holiday_widget_container}>
              <div className={styles.holiday_widget_wrap}>
                {searchWidget !== 'tourpackages' && (
                  <div className={styles.search_widget_container}>
                    <img src="images/tholidays.svg" alt="holiday icon" /> Holidays
                  </div>
                )}

                <div className={styles.search_widget_body}>{renderWidgets()}</div>
                {
                  searchWidget === 'tourpackages' && recentSearchData && recentSearchData.length > 0 && (
                    <div className={styles.recent_search}>
                      Recent Searches :
                      <div className={styles.recent_search_items}>
                        {recentSearchData && recentSearchData.length > 0 ? (
                          recentSearchData?.slice(0, 2)?.map((item, idx) => (
                            <div
                              className={styles.search_item_name}
                              key={idx}
                              onClick={() => {
                                const urlQuery = {
                                  searchby: item.name,
                                  type: item.type,
                                  category: '',
                                  city: '',
                                  month: '',
                                  client: '',
                                }
                                cf.redirectTo('/holiday/search', urlQuery)
                              }
                              }
                            >
                              {item.name}
                            </div>
                          ))
                        ) : (
                          <div className={styles.search_item_name}>No recent searches</div>
                        )}
                      </div>
                    </div>
                  )
                }
              </div>

            </div>

          </div>

          <div className={styles.home_body_container}>
            <div>
              {homeBody.map((res, i) => {
                return (
                  <div key={'homeBodyDsktp' + i}>
                    <div>
                      {!cf.isValueEmpty(res.html)
                        ? parse(res.html)
                        : // <Interweave content={res.html} />
                        ''}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          {
            (searchWidget == 'tourpackages') && (
              <div className={styles.tour_carousel_container}>
                <h2 className={styles.tour_carousel_title}>Trusted partners in every holiday</h2>
                <p className={styles.tourCarousel_text}>we proudly collaborate with a curated network of holiday partners who help us deliver outstanding travel experiences around the world.</p>
                <div className={styles.tour_carousel_bottom}>
                  <TrustedPartnerCarousel partnerdata={partnerdata} isMobile={isMobile} />
                </div>
              </div>
            )
          }


        </div>
      )}

      <ShareToMedia
        theme='theme11'
        setOpenShare={setShareModalOpen}
        openShare={shareModalOpen}
        isMobile={isMobile}
        partUrl={partUrl}
      />
    </>
  )
}
